import { Controller } from "@hotwired/stimulus"

// The General Release Notes scratchpad: autosave as you type (debounced,
// flush on blur), with a VISIBLE save state (Saved / Saving... / Could not
// save, the house rule since the board's silent-rollback blocker). Whole
// blob, last-write-wins, exactly like the sheet cell it replaces.
export default class extends Controller {
  static targets = ["input", "status"]
  static values = { url: String }

  connect() {
    this.lastSaved = this.inputTarget.value
  }

  changed() {
    this.statusTarget.textContent = "Unsaved changes"
    this.statusTarget.className = this.statusClass("text-[#8C8C8C]")
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.flush(), 800)
  }

  flush() {
    clearTimeout(this.timer)
    const value = this.inputTarget.value
    if (value === this.lastSaved) {
      this.statusTarget.textContent = "Saved"
      this.statusTarget.className = this.statusClass("text-[#9CAF88]")
      return
    }

    this.statusTarget.textContent = "Saving..."
    this.statusTarget.className = this.statusClass("text-[#8C8C8C]")
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.urlValue, {
      method: "PATCH",
      headers: { "X-CSRF-Token": token, "Content-Type": "application/json" },
      body: JSON.stringify({ value: value })
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        this.lastSaved = value
        this.statusTarget.textContent = "Saved"
        this.statusTarget.className = this.statusClass("text-[#9CAF88]")
      })
      .catch(() => {
        this.statusTarget.textContent = "Could not save. Keep a copy and retry."
        this.statusTarget.className = this.statusClass("text-[#E57373]")
      })
  }

  statusClass(color) {
    return `text-xs ${color} transition-colors`
  }
}
